var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.getActor.name))]),_c('div',{staticClass:"d-flex justify-content-center"},[_c('round-button',{staticClass:"m-3",attrs:{"value":true},on:{"click":_vm.turnOnAllVars}}),_c('round-button',{staticClass:"m-3",attrs:{"value":false},on:{"click":_vm.turnOffAllVars}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }